// https://lucidlink.atlassian.net/browse/LUCID-21722
import { assertCanHandle } from '@lucidlink/tscore';
import { downloadTextFile } from '@lucidlink/uicore';
export const MimeType = {
    Text: 'text/plain',
    Json: 'application/json',
};
export const downloadWithFilePicker = (name, type, data) => {
    const content = typeof data === 'string' ? data : JSON.stringify(data, null, 2);
    if (window.showSaveFilePicker) {
        void showSaveFilePicker(name, type, content);
    }
    else {
        // Fallback if showSaveFilePicker is not implemented in the current browser
        downloadTextFile({ name, type, content });
    }
};
const getFilePickerOptions = (name, type, directory = 'downloads') => {
    let types = [];
    switch (type) {
        case MimeType.Text:
            types = [
                {
                    description: 'Text File',
                    accept: { [type]: ['.txt', '.log'] },
                },
            ];
            break;
        case MimeType.Json:
            types = [
                {
                    description: 'JSON',
                    accept: { [type]: ['.json'] },
                },
            ];
            break;
    }
    return {
        suggestedName: name,
        startIn: directory,
        types: types,
    };
};
const showSaveFilePicker = async (name, type, content) => {
    if (!window.showSaveFilePicker) {
        throw new Error('File System API is not supported in this browser!');
    }
    try {
        const fileHandle = await window.showSaveFilePicker(getFilePickerOptions(name, type));
        const writable = await fileHandle.createWritable();
        await writable.write(content);
        await writable.close();
    }
    catch (error) {
        assertCanHandle(error, (error) => error instanceof DOMException);
    }
};
